import { createAction, handleActions } from 'redux-actions';
import createRequestSaga, {
  createRequestActionTypes,
} from '../../lib/createRequestSaga';
import { takeLatest } from 'redux-saga/effects';

import * as partnerApi from '../../lib/api/partner';

const [
  LIST_PARTNER_EMPLOYEES,
  LIST_PARTNER_EMPLOYEES_SUCCESS,
  LIST_PARTNER_EMPLOYEES_FAILURE,
] = createRequestActionTypes('partner/LIST_PARTNER_EMPLOYEES');

export const listPartnerEmployees = createAction(
  LIST_PARTNER_EMPLOYEES,
  (id) => id,
);
const listPartnerEmployeesSaga = createRequestSaga(
  LIST_PARTNER_EMPLOYEES,
  partnerApi.getPartnerEmp,
);

const UNLOAD_EMPLOYEES = 'partner/UNLOAD_EMPLOYEES';
export const unloadEmployees = createAction(UNLOAD_EMPLOYEES);

export function* partnerEmployeesSaga() {
  yield takeLatest(LIST_PARTNER_EMPLOYEES, listPartnerEmployeesSaga);
}

const initialState = {
  employees: null,
  error: null,
};

const partnerEmployees = handleActions(
  {
    [LIST_PARTNER_EMPLOYEES_SUCCESS]: (state, { payload: data }) => ({
      ...state,
      employees: data.list.map((emp) => ({
        id: emp.employeeUuid,
        employeeUuid: emp.employeeUuid,
        partnerUuid: emp.partnerUuid,
        employeeNm: emp.employeeNm,
        employeeGrade: emp.employeeGrade,
        dutiesNm: emp.dutiesNm,
        telNo: emp.telNo,
        emailAddr: emp.emailAddr,
        employeeDesc: emp.employeeDesc,
        // crtNm: emp.crtNm,
        // crtDt: emp.crtDt,
      })),
      error: null,
    }),
    [LIST_PARTNER_EMPLOYEES_FAILURE]: (state, { payload: error }) => ({
      ...state,
      error: error,
    }),
    [UNLOAD_EMPLOYEES]: () => initialState,
  },
  initialState,
);

export default partnerEmployees;
